var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { ApiUrls } from '../../enums/api-endpoint/controller.api-endpoint';
import { AuthApiEndpoint } from '../../enums/api-endpoint/auth.api-endpoint';
import { Urls } from '../../enums/urls';
var WorkloadAuthService = /** @class */ (function () {
    function WorkloadAuthService(apiService, router) {
        this.apiService = apiService;
        this.router = router;
    }
    WorkloadAuthService.prototype.getCurrentUser = function () {
        var route = "" + ApiUrls.WlmAuth + AuthApiEndpoint.GetCurrentUser;
        return this.apiService.get(route);
    };
    WorkloadAuthService.prototype.isUserAuthorised = function () {
        var route = "" + ApiUrls.WlmAuth + AuthApiEndpoint.Authenticate;
        return this.apiService.get(route);
    };
    WorkloadAuthService.prototype.getLoggedInUser = function () {
        var route = "" + ApiUrls.WlmAuth + AuthApiEndpoint.GetCurrentUser;
        return this.apiService.get(route);
    };
    WorkloadAuthService.prototype.unAuthUser = function () {
        this.router.navigate([Urls.Unauthorised]);
    };
    WorkloadAuthService.prototype.tryAuthentication = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, isAuth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < 3)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.isUserAuthorised().toPromise()];
                    case 2:
                        isAuth = _a.sent();
                        if (isAuth)
                            return [3 /*break*/, 4];
                        if (i === 2)
                            this.unAuthUser();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    WorkloadAuthService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ApiService,
            Router])
    ], WorkloadAuthService);
    return WorkloadAuthService;
}());
export { WorkloadAuthService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29ya2xvYWQtYXV0aC5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsid29ya2xvYWQtYXV0aC5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUMzQyxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFHekMsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQzVDLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxrREFBa0QsQ0FBQztBQUMzRSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sNENBQTRDLENBQUM7QUFDN0UsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBSXhDO0lBQ0ksNkJBQW9DLFVBQXNCLEVBQ3JDLE1BQWM7UUFEQyxlQUFVLEdBQVYsVUFBVSxDQUFZO1FBQ3JDLFdBQU0sR0FBTixNQUFNLENBQVE7SUFBSSxDQUFDO0lBRWpDLDRDQUFjLEdBQXJCO1FBQ0ksSUFBSSxLQUFLLEdBQUcsS0FBRyxPQUFPLENBQUMsT0FBTyxHQUFHLGVBQWUsQ0FBQyxjQUFnQixDQUFDO1FBQ2xFLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDdEMsQ0FBQztJQUVNLDhDQUFnQixHQUF2QjtRQUNJLElBQUksS0FBSyxHQUFHLEtBQUcsT0FBTyxDQUFDLE9BQU8sR0FBRyxlQUFlLENBQUMsWUFBYyxDQUFDO1FBQ2hFLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDdEMsQ0FBQztJQUVNLDZDQUFlLEdBQXRCO1FBQ0ksSUFBSSxLQUFLLEdBQUcsS0FBRyxPQUFPLENBQUMsT0FBTyxHQUFHLGVBQWUsQ0FBQyxjQUFnQixDQUFDO1FBQ2xFLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDdEMsQ0FBQztJQUVNLHdDQUFVLEdBQWpCO1FBQ0ksSUFBSSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQztJQUM5QyxDQUFDO0lBRVksK0NBQWlCLEdBQTlCOzs7Ozs7d0JBQ2EsQ0FBQyxHQUFHLENBQUM7Ozs2QkFBRSxDQUFBLENBQUMsR0FBRyxDQUFDLENBQUE7d0JBQ0oscUJBQU0sSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUMsU0FBUyxFQUFFLEVBQUE7O3dCQUFsRCxNQUFNLEdBQUcsU0FBeUM7d0JBQ3RELElBQUksTUFBTTs0QkFDTix3QkFBTTt3QkFDVixJQUFJLENBQUMsS0FBSyxDQUFDOzRCQUNQLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQzs7O3dCQUxILENBQUMsRUFBRSxDQUFBOzs0QkFPMUIsc0JBQU8sSUFBSSxFQUFDOzs7O0tBQ2Y7SUFoQ1EsbUJBQW1CO1FBRC9CLFVBQVUsRUFBRTt5Q0FFdUMsVUFBVTtZQUM3QixNQUFNO09BRjFCLG1CQUFtQixDQWlDL0I7SUFBRCwwQkFBQztDQUFBLEFBakNELElBaUNDO1NBakNZLG1CQUFtQiJ9